import { type TooltipProps } from "recharts";
import { useTranslation } from "react-i18next";

import styles from "./ChartTooltip.module.scss";
import { Paragraph } from "@datagame/ui";

export interface ChartTooltipProps extends TooltipProps<number, string> {
  translation: string;
}

export const ChartTooltip = ({ active, payload, label, translation }: ChartTooltipProps) => {
  const { t } = useTranslation();
  if (active && payload && payload.length) {
    return (
      <div className={styles.tooltipWrapper}>
        <div className={styles.tooltip}>
          <Paragraph size="small" weight="font-bold">
            {label}
          </Paragraph>
          <Paragraph color="secondary">{t(translation, { count: payload[0].value })}</Paragraph>
        </div>
      </div>
    );
  }

  return null;
};
